var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4137 11.5713L12.1397 9.89431C11.6871 9.66408 11.1134 9.78754 10.8033 10.1885L9.62283 11.7294C8.45017 11.0962 7.56049 10.5061 6.53886 9.48777C5.42982 8.39748 4.85812 7.48629 4.2511 6.36033L5.75779 5.15714C6.16184 4.84651 6.28407 4.26494 6.04125 3.81455L4.35195 0.575431C4.04517 0.00328776 3.32397 -0.171771 2.79216 0.184783L0.719663 1.59132C0.236076 1.90987 -0.0335068 2.48236 0.00334403 3.04811C0.0467257 3.6322 0.130631 4.38783 0.252211 4.90246C0.872995 7.22283 2.32969 9.63569 4.37295 11.6723C6.41621 13.7089 8.82031 15.1403 11.1392 15.7544C11.6635 15.8968 12.4068 15.9606 12.9962 15.9969C13.5856 16.0332 14.1435 15.75 14.4575 15.2443L15.8033 13.127C16.1837 12.5767 15.9903 11.8604 15.4137 11.5713Z",
    fill: "#43B02A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.be79e6fc145c274b1279c2f60e4e7e98.svg";
export { ForwardRef as ReactComponent };